let handlers_set = new WeakMap();

export default function( t, stop_propagation ){

	if( handlers_set.get(t) )
		return;

	handlers_set.set(t, true);

	t.addEventListener(
		'click',
		(e) => {

			if( t.classList.contains('unconfirmed') ){

				t.classList.remove( 'unconfirmed' )

			} else{

				t.classList.add( 'unconfirmed' );
				t.addEventListener(
					'mouseleave',
					{handleEvent: function(){
						t.classList.remove( 'unconfirmed' );
						t.removeEventListener('mouseleave', this);
					}}
				)

				e.preventDefault();
				if( stop_propagation )
					e.stopImmediatePropagation();
				

			}


		}
	)

}